import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { Calendar } from "../../components/Icons/Icons";
import Loader from "../../components/Loader/Loader";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import { formatEventDateRange, getPlainTextFromWYSIWYG, getYouTubeVideoId } from "../../utils/helper";
import "./Events.scss";
import ReactCountryFlag from "react-country-flag";
import { Image } from 'antd'
import ytPlayBtn from "../../assets/newImages/Play.svg";
import SynthesiaImage from "../../assets/newImages/synthesia.jpg";
import ModalPlayer from "../../components/PlayerModal/playerModal";

const color = ["#E75E0D", "#EB9F11", "#ABC710", "#009340", "#CC0370", "#8366A9", "#149BD7"];

const hasText = (value) => Boolean(value && String(value).trim());

const Events = () => {
    const isSmallScreen = useMediaQuery({ minWidth: 320, maxWidth: 767 });
    const navigate = useNavigate();
    const localData = useSelector((state) => state?.localStorage);
    const { micrositeID, tabConfigId } = localData;

    const [videoUrl, setVideoUrl] = useState("");
    const [mediaType, setMediaType] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [responseData, setResponseData] = useState([]);
    const [failedImageIds, setFailedImageIds] = useState({});

    const PlayVideoHandler = (url, mediaType) => {
        setMediaType(mediaType);
        setVideoUrl(url);
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setVideoUrl("");
    };

    const extractSynthesiaId = (url) => {
        const match = url.match(/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/);
        return match ? match[0] : null;
    };

    const convertToStandardURL = (shortUrl) => {
        if (shortUrl?.indexOf("youtu.be") !== -1) {
            const video_id = shortUrl?.split("youtu.be/")[1].split("?")[0];
            return `https://www.youtube.com/watch?v=${video_id}`;
        }
        return shortUrl;
    };

    const getEventsData = async () => {
        if (!micrositeID || !tabConfigId) return;

        try {
            setLoading(true);

            const response = await getRequest(
                userapiservice.getEventsMicrositeDetailsTabs(micrositeID, tabConfigId),
                null,
                false
            );

            setResponseData(Array.isArray(response) ? response : []);
        } catch (error) {
            const apiErrorMessage =
                error?.response?.data?.errorName ||
                error?.response?.data?.message ||
                error?.message ||
                "Sorry, something went wrong";

            toast.error(<ToastComponent type="Error" message={apiErrorMessage} />);
            setResponseData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getEventsData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [micrositeID, tabConfigId]);

    const handleImageError = (id) => {
        setFailedImageIds((prev) => ({ ...prev, [id]: true }));
    };

    const onCardClickHandler = (event) => {
        navigate(`/microsite/${event.id}/micrositeDetails`, {
            state: { page: "events", data: event },
        });
    };

    return (
        <div className="events-container">
            {loading ? (
                <Loader />
            ) : (
                <div className="events-card-list">
                    <div className="events-card-grid">
                        {responseData.length > 0 ? (
                            responseData.map((event, i) => {
                                const logoUrl = event?.eventLogo?.url;
                                const showImage = Boolean(logoUrl) && !failedImageIds[event.id];
                                const description = getPlainTextFromWYSIWYG(event?.description);
                                const dateRange = formatEventDateRange(event?.startDate, event?.endDate);
                                return (
                                    <motion.div
                                        key={event.id || i}
                                        initial={{ opacity: 0, scale: 0.5 }}
                                        animate={{ opacity: 1, scale: 1 }}
                                        transition={{
                                            duration: 0.8,
                                            delay: 0.5,
                                            ease: [0, 0.71, 0.2, 1.01],
                                        }}
                                        className="events-card"
                                    >


                                        <div className="events-text-container"
                                            onClick={() => onCardClickHandler(event)}

                                        >
                                            {/* {!isSmallScreen && ( */}
                                            <div className="events-card-title" title={event?.eventName}>
                                                {event?.eventLogo?.url ? <Image
                                                    src={event?.eventLogo?.url}

                                                    className="events-card-logo"
                                                    alt={event?.eventName || "Event"}
                                                    preview={false}
                                                /> : event?.eventName}
                                            </div>
                                            {/* )} */}

                                            {hasText(description) && (
                                                <p className="events-card-description">{description}</p>
                                            )}



                                            {dateRange && (
                                                <div className="events-card-date">
                                                    <span><Calendar /></span>
                                                    <span>{dateRange}
                                                        <ReactCountryFlag
                                                            sizes="large"
                                                            className="flag"
                                                            countryCode={event?.country} svg />

                                                    </span>

                                                </div>
                                            )}

                                        </div>


                                        <div
                                            className="events-color-band"
                                            style={{ backgroundColor: color[i % color.length] }}
                                        />
                                        <div className="events-image-container">
                                            {showImage ? (
                                                <div className="events-media">
                                                    <div className="events-slider-img image-container">

                                                        {event?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
                                                            event?.mediaLink?.url ? (
                                                            (() => {
                                                                const videoID = getYouTubeVideoId(event.mediaLink.url);
                                                                if (!videoID) return null;

                                                                return (
                                                                    <div
                                                                        className="media vimeo youtube"
                                                                        onClick={() =>
                                                                            PlayVideoHandler(
                                                                                `https://www.youtube.com/embed/${videoID}?autoplay=1&rel=0`,
                                                                                event.mediaLink.mediaType
                                                                            )
                                                                        }
                                                                    >
                                                                        <div style={{ position: "relative" }}>
                                                                            <img
                                                                                src={`https://img.youtube.com/vi/${videoID}/hqdefault.jpg`}
                                                                                alt="YouTube Video"
                                                                                className="vimeo-video-preview-image video-preview-image"
                                                                            />
                                                                            <img
                                                                                className="ytBtnOverlay"
                                                                                src={ytPlayBtn}
                                                                                alt="Play Button"
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })()
                                                        )
                                                            : event.mediaLink?.mediaType === "VIMEO_MEDIA" &&
                                                                event.mediaLink?.url ? (
                                                                <div
                                                                    className="media vimeo youtube"
                                                                    onClick={() => {
                                                                        PlayVideoHandler(
                                                                            event.mediaLink?.url,
                                                                            event.mediaLink?.mediaType
                                                                        );
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={`https://vumbnail.com/${event.mediaLink?.url?.split("/")[4]
                                                                            }.jpg`}
                                                                        className="vimeo-video-preview-image video-preview-image"
                                                                        alt="thumbnail"
                                                                    />
                                                                    <img className="ytBtnOverlay" alt="ytBtnOverlay" src={ytPlayBtn} />
                                                                </div>
                                                            ) : event.mediaLink?.mediaType ===
                                                                "SYNTHESIA_MEDIA" && event.mediaLink?.url ? (
                                                                (() => {
                                                                    const videoId = extractSynthesiaId(event.mediaLink.url);
                                                                    if (!videoId) return null;

                                                                    return (
                                                                        <div
                                                                            className="media youtube"
                                                                            style={{ objectFit: "contain" }}

                                                                            onClick={() =>
                                                                                PlayVideoHandler(
                                                                                    `https://share.synthesia.io/embeds/videos/${videoId}?autoplay=1`,
                                                                                    event.mediaLink.mediaType
                                                                                )
                                                                            }
                                                                        >
                                                                            <img
                                                                                src={event?.mediaLink?.thumbnailUrl || SynthesiaImage}
                                                                                alt="Synthesia Video"
                                                                                className="yt-video-preview-image video-preview-image"
                                                                            />

                                                                            <img
                                                                                className="ytBtnOverlay"
                                                                                src={ytPlayBtn}
                                                                                alt="Play icon"
                                                                            />
                                                                        </div>
                                                                    );

                                                                })()
                                                            ) : (
                                                                <div className="media" onClick={() => {
                                                                    if (event?.webLink) { window.open(event?.webLink, "_blank") }
                                                                }
                                                                } >
                                                                    <div className="slider-Img">
                                                                        {/* <img
                                                                                            src={event.mediaLink?.url}
                                                                                            alt="slider"
                                                                                            className="home-preview-img"
                                                                                          /> */}
                                                                        <img
                                                                            src={logoUrl}
                                                                            alt={event?.eventName || "Event"}
                                                                            className="events-preview-img"
                                                                            onError={() => handleImageError(event.id)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}

                                                        {/* <img
                                                            src={logoUrl}
                                                            alt={event?.eventName || "Event"}
                                                            className="events-preview-img"
                                                            onError={() => handleImageError(event.id)}
                                                        /> */}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="events-media">
                                                    <div className="events-slider-img" />
                                                </div>
                                            )}


                                        </div>


                                    </motion.div>
                                );
                            })
                        ) : (
                            <div className="events-empty-state">
                                Nothing here at the moment!
                            </div>
                        )}
                    </div>
                    {isModalOpen ? (
                        <ModalPlayer
                            closeModal={handleCancel}
                            mediaLink={videoUrl}
                            mediaType={mediaType}
                        />
                    ) : (
                        ""
                    )}
                </div>
            )}
        </div>
    );
};

export default Events;
